import React from "react";
import { ClipboardList, Activity, Eye, AlertTriangle, GitPullRequestArrow, Gavel } from "lucide-react";

// Faithful in-page reproduction of the GovFlowState operations dashboard using the real design system.
// Illustrative examples only — mirrors real features (assignments, analysis, review, activity).
const mwCards = [
  { icon: ClipboardList, title: "Open Assignments", count: 6, rows: [["SB 1420", "Water Resource Management"], ["HB 305", "Public Records Exemption"]] },
  { icon: Activity, title: "Needs Analysis", count: 3, rows: [["SB 88", "Local Government Finance"], ["HB 741", "Transportation Funding"]] },
  { icon: Eye, title: "Pending Review", count: 2, rows: [["SB 210", "Health Care Access"]] },
];
const activity = [
  ["SB 1420", "STATUS CHANGE", "Referred → In Committee"],
  ["HB 305", "AMENDMENT", "Committee substitute filed"],
  ["SB 88", "VOTE", "Favorable (12–4)"],
  ["HB 741", "VERSION", "Engrossed 1st edition"],
];

export default function MiniDashboard() {
  return (
    <div className="bg-[#F5F7FA]" data-testid="mini-dashboard">
      <div className="flex">
        {/* mini sidebar */}
        <div className="hidden w-40 shrink-0 flex-col gap-1 bg-brand-navy p-3 sm:flex">
          <div className="mb-3 flex items-center gap-2">
            <img src="/govflow-mark.png" alt="" className="h-5 w-5 object-contain" />
            <span className="font-display text-[13px] font-bold text-white">GovFlowState</span>
          </div>
          {["Dashboard", "Executive Brief", "Bills", "Search", "Assignments", "Watchlists", "Reports"].map((l, i) => (
            <div key={l} className={`rounded-md px-2 py-1.5 text-[11px] font-medium ${i === 0 ? "bg-white/10 text-white" : "text-white/55"}`}>{l}</div>
          ))}
        </div>
        {/* content */}
        <div className="min-w-0 flex-1 p-4 sm:p-5">
          <div className="mb-4">
            <div className="font-display text-lg font-extrabold text-brand-ink">Operations</div>
            <div className="text-[11px] text-slate-500">Legislative command center · LIVE data</div>
          </div>
          <div className="mb-2 flex items-center gap-2">
            <span className="grid h-5 w-5 place-items-center rounded bg-brand-navy"><ClipboardList className="h-3 w-3 text-white" /></span>
            <span className="font-display text-[11px] font-bold uppercase tracking-wider text-brand-navy">My Work</span>
          </div>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
            {mwCards.map((c) => (
              <div key={c.title} className="rounded-lg border border-brand-line bg-white p-3 shadow-card">
                <div className="mb-2 flex items-center gap-1.5">
                  <c.icon className="h-3.5 w-3.5 text-brand-civic" />
                  <span className="text-[11px] font-semibold text-brand-ink">{c.title}</span>
                  <span className="ml-auto text-[11px] font-bold text-slate-400">{c.count}</span>
                </div>
                {c.rows.map(([n, t]) => (
                  <div key={n} className="flex items-center gap-1.5 py-0.5">
                    <span className="font-mono text-[10px] font-semibold text-brand-civic">{n}</span>
                    <span className="truncate text-[11px] text-slate-600">{t}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
          <div className="mt-4 mb-2 flex items-center gap-2">
            <span className="grid h-5 w-5 place-items-center rounded bg-brand-navy"><Activity className="h-3 w-3 text-white" /></span>
            <span className="font-display text-[11px] font-bold uppercase tracking-wider text-brand-navy">Legislative Activity</span>
          </div>
          <div className="rounded-lg border border-brand-line bg-white p-3 shadow-card">
            {activity.map(([n, tag, desc], i) => (
              <div key={i} className="flex items-center gap-2 border-b border-brand-line/60 py-1.5 last:border-0">
                <span className="font-mono text-[10px] font-semibold text-brand-civic w-12">{n}</span>
                <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[9px] font-bold uppercase text-slate-600">{tag}</span>
                <span className="truncate text-[11px] text-slate-600">{desc}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
